import { Text } from '@chakra-ui/react';
import Dialog from 'components/Dialog';
import InputMy from 'components/InputMy';

type TProps = {
    open: boolean;
    setOpen: (value: boolean) => void;
    password: string;
    setPassword: (value: string) => void;
    onSubmit: () => void;
    loading: boolean;
};

const ConfirmEmailChangeDialog = ({ open, setOpen, password, setPassword, onSubmit, loading }: TProps) => {
    return (
        <Dialog
            title="Confirm change email address"
            submitText="Confirm"
            onSubmit={onSubmit}
            danger
            forceIsOpen={open}
            setOpen={setOpen}
            disabled={!password.length}
            loading={loading}
        >
            <div>
                <Text color="red.500" fontSize="16px" fontWeight={500} lineHeight={1.5} mb="24px">
                    Are you sure you want to change email address?
                </Text>
                <InputMy
                    type="password"
                    label="Enter password"
                    placeholder="Enter password"
                    value={password}
                    onChangeValue={setPassword}
                />
            </div>
        </Dialog>
    );
};

export default ConfirmEmailChangeDialog;
